import { render } from "./ImpostazioniPage.vue?vue&type=template&id=3d64dfec"
import script from "./ImpostazioniPage.vue?vue&type=script&lang=js"
export * from "./ImpostazioniPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__